var exports = {
  "k": "StackUserAvatar.module__container___d0ZVWE",
};

module.exports = exports;
